import { AppUI } from '@seedlang/state';

export default function eventParamsHelper(params = {}) {
  const viewportWidth = AppUI.layout.viewportWidth;
  const viewportHeight = AppUI.layout.viewportHeight;

  return {
    ...params,
    view_type: AppUI.layout.isMobile ? 'mobile' : 'desktop',
    viewport_width: viewportWidth,
    viewport_height: viewportHeight,
    viewport_proportion: viewportWidth && viewportHeight ? Number((viewportWidth / viewportHeight).toFixed(3)) : null,
  };
}
